import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import SaudeService from '../../../../../services/saude-auth';
import Inscricao from './inscricao';


const ListarSaude = () => {


    const [inscricoes, setInscricoes] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [inscricao, setInscricao] = useState("");



    async function fetchInscricoesIn() {
        const response = await SaudeService.listar();
        if (response.data.length >= 1) {
            setInscricoes(response.data)
            setVazio(false)
        } else {
            setInscricoes([])
            setVazio(true)
        }
    }


    useEffect(() => {
        fetchInscricoesIn();
    }, []);

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a inscrição?')) {
            await SaudeService.deletar(id)
            alert("Inscrição deletada com sucesso!")
            fetchInscricoesIn();
        }
    }

    const handleEditar = (id) => {
        setInscricao(id);
        setEditar(true)
    }


    if (editar) {
        return (
            <Navigate to={`/restrito/saude/conferencia/editar/${inscricao}`} />
        )
    } else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setInscricoes={setInscricoes}
                        setVazio={setVazio}
                        fetchInscricoesIn={fetchInscricoesIn}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={3}>
                            {inscricoes.map((inscricao, index) =>
                                <Inscricao
                                    fetchInscricoesIn={fetchInscricoesIn}
                                    inscricao={inscricao}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarSaude;